import {
    ICadastrarFormularios,
    IFormularios,
    IFormulariosRespondidos,
    IListaPesquisaSatisfacaoRespostasFormularioHelpdesk,
    IListarFormRespondido,
    IListarFormularios,
    IResponderPesquisaSatisfacao,
    IRetornoCriarFormulario,
} from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListaPesquisaSatisfacaoRespostasFormularioHelpdeskService(
    idContaChat: number,
    idCaso: number
) {
    return Service(
        Axios.get<Array<IListaPesquisaSatisfacaoRespostasFormularioHelpdesk>>(
            `/home/pesquisasatisfacaoperguntaresposta/listapesquisasatisfacaorespostasformulariohelpdesk?idContaChat=${idContaChat}&idCaso=${idCaso}`
        )
    );
}

export async function GetTemplateFormularioService(
    idFormulario?: number,
    idTipoCaso?: number,
    idCaso?: number
) {
    return Service(
        Axios.get(
            `/home/pesquisasatisfacaoformulario/gettemplateformulario?idFormulario=${idFormulario}&idTipoCaso=${idTipoCaso}&idCaso=${idCaso}`
        )
    );
}

export async function CadastrarPesquisaSatisfacaoFormularioRespondidoService(
    idCaso: number,
    requestBody: IResponderPesquisaSatisfacao
) {
    return Service(
        Axios.post(
            `/home/pesquisasatisfacaoformulario/cadastrarpesquisasatisfacaoformulariorespondido?idCaso=${idCaso}`,
            requestBody
        )
    );
}

export async function GetTermoRecebimentoHTMLService(
    idFormulario?: number,
    idTipoCaso?: number,
    idCaso?: number,
    cdEtapa?: string,
    flExportar?: boolean
) {
    return Service(
        Axios.get(
            `/home/pesquisasatisfacaoformulario/gettermoderecebimentohtml?idFormulario=${idFormulario}&idTipoCaso=${idTipoCaso}&idCaso=${idCaso}&cdEtapa=${cdEtapa}&flExportar=${flExportar}`
        )
    );
}

export async function ListarFormulariosService() {
    return Service(
        Axios.get<Array<IListarFormularios>>(
            `/home/pesquisasatisfacaoformulario/listarpesquisasatisfacaoformularios`
        )
    );
}

export async function ListarPesquisaRespondidaService(
    idCaso: number,
    nrAgrupamento?: string
) {
    return Service(
        Axios.get<Array<IListarFormRespondido>>(
            `/home/pesquisasatisfacaoperguntaresposta/listapesquisasatisfacaorespostasformulario?idCaso=${idCaso}&nrAgrupamento=${
                nrAgrupamento ?? 0
            }`
        )
    );
}
export async function GetFormulariosService(idFormulario: number) {
    return Service(
        Axios.get<ICadastrarFormularios>(
            `/home/pesquisasatisfacaoformulario/getpesquisasatisfacaoformulario?idFormulario=${idFormulario}`
        )
    );
}
export async function CadastrarFormulariosService(
    requestBody: ICadastrarFormularios
) {
    return Service(
        Axios.post<IRetornoCriarFormulario>(
            `/home/pesquisasatisfacaoformulario/cadastrarformulario`,
            requestBody
        )
    );
}
export async function AtualizarFormulariosService(
    requestBody: ICadastrarFormularios
) {
    return Service(
        Axios.put<IRetornoCriarFormulario>(
            `/home/pesquisasatisfacaoformulario/atualizarpesquisasatisfacaoformulario`,
            requestBody
        )
    );
}

export async function CadastrarPesquisaRespondidaService(
    idCaso: number,
    requestBody: IResponderPesquisaSatisfacao
) {
    return Service(
        Axios.post(
            `/home/pesquisasatisfacaoformulario/cadastrarpesquisasatisfacaoformulariorespondido?idCaso=${idCaso}`,
            requestBody
        )
    );
}

export async function DeletarFormService(idFormulario: number) {
    return Service(
        Axios.delete(
            `/home/pesquisasatisfacaoformulario/deletarpesquisasatisfacaoformulario?idPesquisaSatisfacaoFormulario=${idFormulario}`
        )
    );
}

export async function BuscarFormularioPeloNomeService(
    cdEtapa: string,
    tpPesquisa?: "AssistenciaTec" | "Vistoria"
) {
    return Service(
        Axios.get<IFormularios>(
            `/home/pesquisasatisfacaoformulario/getpesquisasatisfacaoformularionome?tpPesquisa=${
                tpPesquisa ?? "AssistenciaTec"
            }&CdEtapa=${cdEtapa}`
        )
    );
}

export async function ListarFormulariosRespondidosServices(idConta: number) {
    return Service(
        Axios.get<Array<IFormulariosRespondidos>>(
            `/home/pesquisasatisfacaoformulario/listarformulariosrespondidosporcliente?idConta=${idConta}`
        )
    );
}

export async function ListarFormulariosRespondidosPorCasoService(
    idCaso: number
) {
    return Service(
        Axios.get<Array<IFormulariosRespondidos>>(
            `/home/pesquisasatisfacaoformulario/listarformulariosrespondidosporcaso?idCaso=${idCaso}`
        )
    );
}

export async function BuscarAgrupamentoFormularioService(
    idFormulario: number,
    idCaso: number
) {
    return Service(
        Axios.get<number | undefined>(
            `/home/pesquisasatisfacaoformulario/getagrupamentoformulario?idFormulario=${idFormulario}&idCaso=${idCaso}`
        )
    );
}
